/** Distance from the body's end at which a scroll can request another result page. */
const REACH_END_THRESHOLD_PX = 64;
/**
 * Keeps scroll measurement in the panel while reporting only a semantic end signal.
 * The existing command-menu scroll observer remains independent of continuation.
 */
export function panelScrollHandler(onReachEnd, onBodyScroll) {
    if (onReachEnd === undefined)
        return onBodyScroll;
    return (event) => {
        onBodyScroll?.(event);
        const scrollContainer = event.currentTarget;
        if (scrollContainer.scrollTop > 0 &&
            scrollContainer.scrollHeight - scrollContainer.scrollTop - scrollContainer.clientHeight <=
                REACH_END_THRESHOLD_PX) {
            onReachEnd();
        }
    };
}
//# sourceMappingURL=panelScroll.js.map